export default function formatDateTime(dateTime: string | number | Date): string {
  const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
  return new Date(dateTime).toLocaleDateString("en-GB", options);
}

export function formatDate(dateTime: string | number | Date): string {
  const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(dateTime).toLocaleDateString("en-US", options);
}
